export default __webpack_public_path__ + "static/media/accepted.ceac9ea3.svg";